export default {
  fontFamily: 'HK-Grotesk, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',
};
